export default "__VITE_ASSET__0U9hlKuG__"